import React from "react";
import { Panel } from "../../components/ui/dashboard";

const UpdateStatus: React.FC = () => {
  return (
    <div className="p-4 md:p-6 space-y-4">
      <Panel title="Update Trip Status" subtitle="Status + GPS location updates">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <select className="border rounded-lg px-3 py-2 text-sm">
            <option>picked_up</option>
            <option>checkpoint</option>
            <option>out_for_delivery</option>
            <option>delivered</option>
          </select>
          <input className="border rounded-lg px-3 py-2 text-sm" placeholder="Location note" />
          <input className="border rounded-lg px-3 py-2 text-sm" placeholder="Latitude" />
          <input className="border rounded-lg px-3 py-2 text-sm" placeholder="Longitude" />
        </div>
        <div className="mt-4 flex justify-end">
          <button className="px-3 py-2 rounded-lg text-sm bg-indigo-600 text-white">Submit Update</button>
        </div>
      </Panel>
    </div>
  );
};

export default UpdateStatus;